import React from 'react';

import useTranslate from '@src/i18n/useTranslate';

import { Title } from './styles';

interface ParagraphProps extends Omit<React.HTMLAttributes<HTMLParagraphElement>, 'children'> {
  label?: string;
}

const PhoneVerificationTitle = ({ label, ...rest }: ParagraphProps) => {
  const { i18n } = useTranslate();

  return <Title {...rest}>{label ?? i18n('phone_verification_title')}</Title>;
};

export default PhoneVerificationTitle;
